import React, { useState, useEffect } from 'react'
import usePageTitle from '../hooks/usePageTitle'
import { CONTAINER_CONTENT_CLASS } from './signatures/Signatures'
import { useAuth } from '../AuthContext'
import MarketingOnboarding from '../components/MarketingOnboarding'
import { useAxios } from '../core/_axios'
import { User } from '../core/_models'

function Dashboard() {
  usePageTitle('Dashboard')
  const { currentUser } = useAuth()
  const axios = useAxios()
  const [showOnboarding, setShowOnboarding] = useState(false)

  useEffect(() => {
    // Check if user is a marketing lead who needs onboarding
    if (currentUser?.public_data?.is_marketing_lead && currentUser?.public_data?.needs_onboarding) {
      setShowOnboarding(true)
    }
  }, [currentUser])

  const handleOnboardingComplete = async () => {
    // Update user's public_data to mark onboarding as complete
    try {
      // Note: We'd need to add an endpoint to update user data, for now just hide locally
      setShowOnboarding(false)
      
      // TODO: Add API call to update user's needs_onboarding flag to false
      // await axios.put('/api/v1/app/authenticated/management/update-onboarding-status', {
      //   needs_onboarding: false
      // })
    } catch (error) {
      console.error('Failed to update onboarding status:', error)
      setShowOnboarding(false)
    }
  }

  return (
    <>
      {showOnboarding && (
        <MarketingOnboarding onComplete={handleOnboardingComplete} />
      )}
      <div className="container-fixed">
        <div className={CONTAINER_CONTENT_CLASS}>
          <div className="flex flex-col justify-center gap-2">
            <h1 className="text-xl font-semibold leading-none text-gray-900">
              Dashboard
            </h1>
            <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
              Central Hub for Personal Customization
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <a className="btn btn-sm btn-light" href="html/demo1/public-profile/profiles/default.html">
              View Profile
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
